import React from "react";
import { useAccess } from "providers/access";
import { SummaryApp } from "@appsinti/common-utils/interfaces/IApp";
import ComponentPicker from "./ComponentPicker";
import styled from "styled-components";
import { INPUTS } from "@etiquette-ui/colors";

export const BodyContainer = styled.div<{ $bodyHeight: number }>`
  background-color: ${INPUTS};
  height: ${({ $bodyHeight }) => $bodyHeight}px;
  max-height: ${({ $bodyHeight }) => $bodyHeight}px;
  position: relative;
  overflow-y: hidden;
  display: flex;
  gap: 6px;
  padding: 10px;

  @media screen and (max-height: 750px) {
    padding: 8px;
  }

  @media screen and (max-height: 710px) {
    padding: 6px;
  }
`;

const Body: React.FC<{ bodyHeight: number, summaryApp: SummaryApp }> = ({ bodyHeight, summaryApp }) => {
  const { groups } = useAccess();
  const groupCount = Object.keys(groups).length;
  return (
    <BodyContainer
      $bodyHeight={bodyHeight}
      className={groupCount > 3 ? "core-summary-body row" : "core-summary-body"}
    >
      <ComponentPicker app={summaryApp} groups={groups} />
    </BodyContainer>
  );
};

export default Body;
